import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MaterialModule } from './material.module';
import { PipesDirectivesModule } from './pipes-directives.module';
import { FormComponentsModule } from './form-components.module';

import { FlexLayoutModule } from '@angular/flex-layout';

// Components
import { FeeTotalsComponent } from '../../components/fees-split/fees/fee-totals/fee-totals.component';
import { NotesFieldComponent } from '../../components/forms/notes-field/notes-field.component';
import { NonStandardFeeComponent } from '../../components/fees-split/fees/non-standard-fee/non-standard-fee.component';
import { DownloadDocsComponent } from '../../components/download-docs/download-docs.component';
import { CustomDateRangePickerComponent }  from  '../../components/shared/custom-date-range-picker/custom-date-range-picker.component';

// Starts - Lazy loading strategy
import { SubtabsComponent } from '../../components/invoice-landing/invoice-sub-tabs/subtabs.component';
import { InvoiceDateRangePickerComponent } from '../../components/invoice-landing/date-range-picker/date-range-picker.component';
import { SinglePageValidationComponent } from '../../components/review/single-page-validation/single-page-validation.component';

// Landing & Transaction Summary
import { DateCreatedComponent } from '../../components/invoice-landing/invoice-grid/date-created/date-created.component';
import { FeeSplitComponent } from '../../components/fees-split/fee-split/fee-split.component';
import { DealFileChecklistComponent } from '../../components/financials/deal-file-checklist/deal-file-checklist.component';
import { GoogleMapComponent } from '../../components/google-map/google-map.component';
import { InvoiceStatusTypesComponent } from '../../components/invoice-landing/invoice-status/invoice-status.component';


import { PartiesComponent } from '../../components/financials/parties/parties.component';
import { BillToFinancialsComponent } from '../../components/financials/bill-to-financials/bill-to-financials.component';

@NgModule({
  declarations: [
    FeeTotalsComponent,
    NotesFieldComponent,
    NonStandardFeeComponent,
    SubtabsComponent,
    InvoiceDateRangePickerComponent,
    SinglePageValidationComponent,
    CustomDateRangePickerComponent,
    
    // Reports ?
    DateCreatedComponent,
    FeeSplitComponent,
    DealFileChecklistComponent,
    DownloadDocsComponent,
    GoogleMapComponent,
    InvoiceStatusTypesComponent,
    PartiesComponent,
    BillToFinancialsComponent,
    
  ],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    FlexLayoutModule,
    PipesDirectivesModule,
    FormComponentsModule
  ],
  exports: [
    FlexLayoutModule,
    MaterialModule,

    // Components
    FeeTotalsComponent,
    NotesFieldComponent,
    NonStandardFeeComponent,
    SubtabsComponent,
    InvoiceDateRangePickerComponent,
    SinglePageValidationComponent,
    FeeSplitComponent,
    DealFileChecklistComponent,
    DownloadDocsComponent,
    GoogleMapComponent,
    InvoiceStatusTypesComponent,
    CustomDateRangePickerComponent,
    PartiesComponent,
    BillToFinancialsComponent
  ]
})
export class CommonComponentsModule { }
